const ITEMS = [
  "Multi-Tenant Warehouses",
  "Strict RBAC",
  "Order Validation",
  "Partial Inbound Receiving",
  "Damaged Quarantine",
  "Auto Restock Returns",
  "Per-Store Invoicing",
  "Live Activity Log",
  "Low-Stock Alerts",
  "VA Agency Workflows",
];

export const MarqueeStrip = () => (
  <section className="py-9 border-y border-slate-200 bg-white overflow-hidden" data-testid="marquee-strip">
    <div className="lp-marquee-track">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={i}
          className="lp-display shrink-0 mx-8 text-sm md:text-base uppercase tracking-[0.25em] text-slate-500 flex items-center gap-8"
        >
          {item}
          <span className="h-1.5 w-1.5 rounded-full bg-blue-500" />
        </span>
      ))}
    </div>
  </section>
);
